"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "34", height: "40", viewBox: "0 0 34 40", className: "Icon toolbar-trash", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-toolbar-trash" },
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.729", "in": "SourceGraphic" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "b-toolbar-trash" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#CDCDCD" }),
                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#DDD" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#C3C3C3" })
            ),
            _react2.default.createElement("path", { d: "M17 10c8.284 0 15-1.79 15-4s-6.716-4-15-4C8.716 2 2 3.79 2 6s6.716 4 15 4z", id: "c-toolbar-trash" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "d-toolbar-trash" },
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "SourceAlpha", result: "shadowBlurInner1" }),
                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0", "in": "shadowInnerInner1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M1 6c0-2.761 7.163-5 16-5s16 2.239 16 5c0 .11-3 29-3 29 0 2.21-5.82 4-13 4S4 37.21 4 35C4 35 1 6.11 1 6z", fill: "#F9F9F9" }),
            _react2.default.createElement("path", { d: "M1.024 6c0 .11 3 29 3 29 0 2.21 5.82 4 13 4s13-1.79 13-4c0 0 3-28.89 3-29 0-2.761-7.164-5-16-5-8.837 0-16 2.239-16 5zm16-6c10 0 17.5 2.5 17 6-.016.107-.334 3.336-1.501 14.603l-1.036 9.984-.34 3.275-.129 1.241C31.024 38.08 24.778 40 17.024 40c-7.756 0-14-1.921-14-5-.018-.122-.018-.122-.124-1.138l-.34-3.275-1.031-9.943C.357 9.336.024 6.108.024 6c-.5-3.5 7-6 17-6z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { fill: "#FFF", filter: "url(#a-toolbar-trash)", d: "M23.5 37L27 9h-7z", fillOpacity: ".9" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "url(#b-toolbar-trash)", xlinkHref: "#c-toolbar-trash" }),
                _react2.default.createElement("use", { fill: "#000", filter: "url(#d-toolbar-trash)", xlinkHref: "#c-toolbar-trash" })
            ),
            _react2.default.createElement("path", { d: "M17 10c8.284 0 15-1.79 15-4s-6.716-4-15-4C8.716 2 2 3.79 2 6s6.716 4 15 4zm0 1C8.083 11 1 9.111 1 6c0-3.111 7.083-5 16-5s16 1.889 16 5c0 3.111-7.083 5-16 5z", fill: "#FFF" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-trash.js
// module id = 1854
// module chunks = 0